const styles = (theme) => ({
  root: {
    paddingTop: theme.spacing.unit * 2,
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing.unit,
    },
  },
  rootSmall: {
    padding: 0,
  },
  buttonCreate: {
    fontSize: '1.3125rem',
    fontFamily: 'Calibre',
    lineHeight: 1.4,
    color: theme.palette.text.dark,
    padding: 0,
    overflow: 'visible',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:hover span': {
      textDecoration: 'underline',
    },
    '&:hover div ': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.375rem',
    },
  },
  buttonCreateFilled: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.text.dark,
    borderRadius: '50px',
    padding: '10px 20px 10px 10px',
  },
  buttonCreateSmall: {
    fontSize: '1.1875rem',
  },
  buttonWrap: {
    display: 'block',
    height: 'auto',
  },
  fab: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.primary.dark,
    backgroundColor: theme.palette.background.lighter,
    color: theme.palette.text.dark,
    boxShadow: 'none',
  },
  fabFilled: {
    border: 'none',
    backgroundColor: theme.palette.primary.dark,
    color: 'white',
    boxShadow: 'none',
  },
  fabWrap: {
    display: 'flex',
    margin: '0 auto',
  },
  fabSmall: {
    width: 45,
    height: 45,
    minWidth: 45,
    '& svg': {
      fontSize: '1.75rem',
    },
  },
  buttonInner: {
    marginLeft: theme.spacing.unit * 1.5,
    textAlign: 'left',
  },
  buttonInnerWrap: {
    textAlign: 'center',
    marginTop: theme.spacing.unit,
    display: 'block',
  },
  buttonInnerRight: {
    marginLeft: 0,
    marginRight: theme.spacing.unit * 1.5,
  },
});

export default styles;
